import { TRACES_SAMPLE_RATE } from './sentry.constants';
import { TSentryTracesSample } from '.';

export const tracesSampler = (
    samplingContext: TSentryTracesSample,
    sampleRate: number = TRACES_SAMPLE_RATE
) =>
    samplingContext.transactionContext.name.includes('/api/heartbeat')
        ? 0
        : sampleRate;
